var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.5C7.79086 4.5 6 6.29086 6 8.5V56.5C6 58.7091 7.79086 60.5 10 60.5H54C56.2091 60.5 58 58.7091 58 56.5V8.5C58 6.29086 56.2091 4.5 54 4.5H10ZM48 31.5C50.2091 31.5 52 29.7091 52 27.5C52 25.2909 50.2091 23.5 48 23.5C45.7909 23.5 44 25.2909 44 27.5C44 29.7091 45.7909 31.5 48 31.5ZM48 42.5C50.2091 42.5 52 40.7091 52 38.5C52 36.2909 50.2091 34.5 48 34.5C45.7909 34.5 44 36.2909 44 38.5C44 40.7091 45.7909 42.5 48 42.5ZM52 49.5C52 51.7091 50.2091 53.5 48 53.5C45.7909 53.5 44 51.7091 44 49.5C44 47.2909 45.7909 45.5 48 45.5C50.2091 45.5 52 47.2909 52 49.5Z",
    fill: "#D7BDFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25.5,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#AF7BFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3335,
    y: 13.5,
    width: 16,
    height: 4,
    rx: 2,
    fill: "#AF7BFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 36.5,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#AF7BFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 47.5,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#AF7BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/CheckList.7405b8255bb96ebf2b6d5ee0db3a3fa2.svg";
export { ForwardRef as ReactComponent };